"use client";

import { Button } from "@/components/ui/button";
import {
    Sheet,
    SheetContent,
    SheetFooter,
    SheetHeader,
    SheetTitle,
    SheetTrigger
} from "@/components/ui/sheet";
import useCartStore from "@/src/store/useCartStore";
import { PersianNum } from "@/src/tools";
import { Archive } from "lucide-react";
import { useRouter } from "next/navigation";
import LoadProductHeader from "./LoadProductHeader";

const BasketHeader = () => {
    const router = useRouter();

    const itemCount = useCartStore(state =>
        state.cart.reduce((total, item) => total + item.count, 0)
    );
    return (
        <Sheet>
            <SheetTrigger asChild className="relative">
                <span className="relative h-8 w-8 flex items-center justify-center rounded">
                    <Archive className="size-6" />
                    {itemCount > 0 && (
                        <span className="absolute top-0 right-0 inline-flex items-center justify-center h-5 w-5 bg-green-800 text-xs font-bold leading-none transform translate-x-1/2 -translate-y-1/2 text-white rounded-full">
                            {PersianNum(itemCount)}
                        </span>
                    )}
                </span>
            </SheetTrigger>
            <SheetContent className="overflow-auto w-[300px]" side="left">
                <SheetHeader>
                    <SheetTitle className="text-right">سبد خرید</SheetTitle>
                </SheetHeader>
                <div style={{ direction: "rtl" }} className="p-1">
                    {itemCount > 0 ? <LoadProductHeader /> : <span>محصولی وجود ندارد</span>}
                </div>
                <SheetFooter>
                    <Button
                        onClick={() => router.push("/order/check")}
                        className="w-full mt-2"
                        variant="secondary"
                    >
                        مشاهده سبد خرید
                    </Button>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
};

export default BasketHeader;
